import { Link, useParams } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryTabs() {
  const { slug } = useParams<{ slug: string }>();

  return (
    <div className="w-full overflow-x-auto scrollbar-hide">
      <div className="flex items-center gap-2 pb-2 min-w-max">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className={`whitespace-nowrap flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer border ${
              slug === cat.slug
                ? 'bg-primary-500 text-background-50 border-primary-500'
                : 'bg-background-50 text-foreground-700 border-background-200/70 hover:border-primary-200 hover:text-primary-500'
            }`}
          >
            <i className={`${cat.icon} text-sm`} />
            {cat.name}
          </Link>
        ))}
      </div>
    </div>
  );
}